import React from "react";
import { bool, string, element, oneOfType } from "prop-types";
import { EventCard } from "../Components/EventCard";

const AuctionCard = ({
    title,
    startDate,
    endDate,
    comingSoon,
    image,
    webp,
    link,
    linkLabel,
    venue,
    address
}) => {
    let linkTarget = "_blank";

    if(!link.includes("http")){
        link = `/auctions/${link}`;
        linkTarget = "_self";
    }

    return(
        <EventCard
            title={title}
            startDate={spannedDate(startDate)}
            endDate={spannedDate(endDate)}
            comingSoon={comingSoon}
            image={image}
            webp={webp}
            link={link}
            linkLabel={linkLabel}
            linkTarget={linkTarget}
            venue={venue}
            address={address}
        />
    );
};

const spannedDate = (dateString) => (
    <span className="SpannedDate">
        {dateString.split(" ").map(segment => {
            return <span className="SpannedDateSection" key={segment}>{segment}</span>;
        })}
    </span>
);

AuctionCard.propTypes = {
    title: string,
    image: string,
    webp: string,
    link: string,
    linkLabel: string,
    startDate: oneOfType([
        bool,
        string,
        element
    ]),
    endDate: oneOfType([
        bool,
        string,
        element
    ]),
    comingSoon: bool,
    venue: string,
    address: string
};

export default AuctionCard;